import { renderOptionsChain } from '../components/OptionsChain';
import { renderPhase2OptionsMicrostructure } from '../components/charts/Phase2OptionsMicrostructure';
import { isFeatureEnabled } from '../services/runtime-config';

type CommandEventDetail = {
  symbol?: string;
};

let detachCommandHandlers: (() => void) | null = null;

export function renderOptions(): string {
  return `
    <div id="options-command-context" class="text-xs text-muted" style="margin-bottom: var(--space-3);"></div>
    <div id="options-content"></div>
  `;
}

export function initOptions(): void {
  const contentEl = document.getElementById('options-content');
  const contextEl = document.getElementById('options-command-context');
  if (!contentEl) return;

  const setContext = (value: string): void => {
    if (!contextEl) return;
    contextEl.textContent = value;
  };

  if (isFeatureEnabled('charts_v2_engine')) {
    renderPhase2OptionsMicrostructure(contentEl);
  } else {
    renderOptionsChain(contentEl);
  }

  if (detachCommandHandlers) {
    detachCommandHandlers();
  }

  const onChain = () => {
    setContext('Command: CHAIN');
  };

  const onSymbol = (event: Event) => {
    const detail = (event as CustomEvent<CommandEventDetail>).detail;
    const symbol = detail?.symbol?.toUpperCase() || '';
    if (!symbol) return;
    setContext(`Command: SYMBOL ${symbol} GO`);
    document.dispatchEvent(new CustomEvent('imm:options:symbol', { detail: { symbol } }));
  };

  document.addEventListener('imm:command:chain', onChain);
  document.addEventListener('imm:command:symbol', onSymbol as EventListener);

  detachCommandHandlers = () => {
    document.removeEventListener('imm:command:chain', onChain);
    document.removeEventListener('imm:command:symbol', onSymbol as EventListener);
  };
}
